import { styled } from '@mui/material/styles';
import { Button, Typography } from '@mui/material';

const rowWidth = { width: 'calc(100% - 50px)' };

export const TmContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobileXS',
})(({ isMobileXS }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: isMobileXS ? '100%' : 450,
  margin: '0 auto',
}));

export const RealmResetDiv = styled('div')(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.grey['600'],

  '& .MuiButton-label': {
    color: theme.palette.secondary.main,
  },
  '& .MuiIcon-root': {
    fontSize: 14,
  },
}));

export const Header = styled(Typography)(({ theme }) => ({
  margin: `${theme.spacing(1)} 0`,
  fontWeight: 'bold',
  ...rowWidth,
}));

export const Grouping = styled('div')(({ theme }) => ({
  margin: `${theme.spacing(2)} 0`,
}));

export const NoneYet = styled('div')(({ theme }) => ({
  fontStyle: 'italic',
  fontSize: 14,
  margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
  ...rowWidth,
}));

export const FlexRow = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginBottom: 2,
});

export const TemplateButtonStyled = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  textTransform: 'none',
  justifyContent: 'flex-start',
  color: theme.palette.text.primary,
  ...rowWidth,

  '& .MuiButton-label': {
    justifyContent: 'flex-start',
  },

  '& .MuiIcon-root': {
    color: theme.palette.secondary.main,
  },
}));

export const TemplateButton2 = styled(Button)(({ theme }) => ({
  width: 40,
  minWidth: 'auto',
  marginLeft: theme.spacing(2),
}));
